(function () {
  'use strict';

  function readWishlist() {
    try {
      var storedWishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
      return Array.isArray(storedWishlist) ? storedWishlist : [];
    } catch (error) {
      return [];
    }
  }

  function localizedUrl(path) {
    var recommendationsSection = document.querySelector('.related-product');
    var sectionRoot = recommendationsSection ? recommendationsSection.dataset.productsRoot : '';
    var shopifyRoot = sectionRoot || (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
    return shopifyRoot.replace(/\/$/, '') + '/' + path.replace(/^\//, '');
  }

  async function renderRecommendations(product) {
    var recommendationsSection = document.querySelector('.related-product');

    if (!recommendationsSection) return;

    var recommendationsUrl = new URL(
      recommendationsSection.dataset.recommendationsUrl || localizedUrl('recommendations/products'),
      window.location.origin
    );

    recommendationsUrl.searchParams.set('section_id', recommendationsSection.dataset.sectionId);
    recommendationsUrl.searchParams.set('product_id', product.id);
    recommendationsUrl.searchParams.set('limit', '4');

    var response = await fetch(recommendationsUrl.toString());

    if (!response.ok) return;

    var responseText = await response.text();
    var responseDocument = new DOMParser().parseFromString(responseText, 'text/html');
    var newContent = responseDocument.querySelector('.related-slider');
    var currentContent = recommendationsSection.querySelector('.related-slider');

    if (newContent && currentContent) currentContent.innerHTML = newContent.innerHTML;
  }

  async function initializeRecommendations() {
    var wishlist = readWishlist();

    if (!wishlist.length) return;

    try {
      for (var index = 0; index < wishlist.length; index += 1) {
        var response = await fetch(localizedUrl('products/' + encodeURIComponent(wishlist[index]) + '.js'));

        if (!response.ok) continue;

        var product = await response.json();

        if (product && product.id) {
          await renderRecommendations(product);
          return;
        }
      }
    } catch (error) {
      return;
    }
  }

  initializeRecommendations();
})();

